import React, { useState } from "react";
import { useGetAssignedActorQuery } from "@/redux/feature/orderManagement/actorSelection/actorSelectionApi";
import { formatDate } from "@/utils/formateData";
import { getDaysDifference } from "@/utils/getDaysDifference";
import { useParams } from "react-router-dom";
import ActorDetails from "./ActorDetails";
import { TResponseOrderDetails } from "@/types/projectType";
import Modal from "@/components/ui/Modal";

interface DataItemProps {
  title: string;
  children: React.ReactNode;
}

const DataItem = ({ title, children }: DataItemProps) => (
  <div className="space-y-[6px]">
    <h5 className="text-sm text-[#98A2B3] font-normal leading-4 tracking-[-1%] text-start min-w-[50px] mb-1">
      {title}
    </h5>
    <div className="text-start text-xs md:text-sm text-[#667085] leading-[18px] tracking-[-1%] font-medium md:table-row flex flex-wrap">
      {children}
    </div>
  </div>
);

const ProjectDetailsTable = ({ data }: { data: TResponseOrderDetails }) => {
  const startedOn = formatDate(data?.createdOn);
  const deliveryOn = formatDate(data?.deadline);

  const [showActorDetailsModal, setShowActorDetailsModal] = useState(false);

  const DueDate = getDaysDifference(data?.createdOn, data?.deadline);


  // if its 

  const orderStatus = data?.orderStatus?.isPending ? (
    <span className="bg-[#FBF1DA] text-[#714B00] px-2 py-1 rounded-full inline-block whitespace-nowrap">
      Pending
    </span>
  ) : data?.orderStatus?.isProgress ? (
    <span className="bg-[#FBF1DA] text-[#714B00] px-2 py-1 rounded-full inline-block whitespace-nowrap">
      In Progress
    </span>
  ) : data?.orderStatus?.isCompleted ? (
    <span className="bg-[#12B76A] text-white px-2 py-1 rounded-full inline-block whitespace-nowrap">
      Completed
    </span>
  ) : (
    "Unknown"
  );

  const { id: orderId } = useParams();
  const { data: assignedActor } = useGetAssignedActorQuery({
    orderId,
    videoId: 1,
  });

  if (!data) {
    return null;
  }

  return (
    <div className="mt-10 overflow-x-auto grid grid-cols-3 md:flex md:items-center gap-8 md:gap-10 flex-wrap">
      <>
        <DataItem title="Client">
          <p className="w-full md:max-w-[300px] truncate">{data?.clientId?.businessName}</p>
        </DataItem>
        <DataItem title="Industry">{data?.clientId?.industry}</DataItem>
        {/* <DataItem title="Video type">
          {data?.orderPlanDetails?.selectedVideoType?.title}
        </DataItem> */}
        {/* <DataItem title="Video nature">Promotional</DataItem> */}
        <DataItem title="Quantity">
          {data?.orderPlanDetails?.quantity} videos
        </DataItem>
        <DataItem title="Started on">{startedOn}</DataItem>
        <DataItem title="Delivery on">{deliveryOn}</DataItem>

        <DataItem title="Status">{orderStatus}</DataItem>
        <DataItem title="Due time">
          <span className="flex gap-1">
            {DueDate} days
            {/* <span className="text-[#6941C6] cursor-pointer hidden md:block">
              (view activities)
            </span> */}
          </span>
        </DataItem>
        <Modal
          width="555px"
          isOpen={showActorDetailsModal}
          setOpen={setShowActorDetailsModal}
          padding={"0px"}
        >
          <ActorDetails actor={assignedActor?.data?.actor} />
        </Modal>
      </>
    </div>
  );
};

export default ProjectDetailsTable;
